import { Button } from "../../../../../components";
import { InvestmentConclusionScores } from "../InvestmentConclusionScores/InvestmentConclusionScores";
import { ScoreCard } from "../ScoreCard";

export const InvestmentConclusion = ({
  investmentStrategyAndConclusion,
  executiveSummary,
  isLoading,
}) => {
  return (
    <div className="flex flex-col gap-4 sm:gap-7 items-stretch w-full">
      <h2 className="font-bold">Investment conclusion</h2>
      <InvestmentConclusionScores
        gatewayScore={isLoading ? 0 : executiveSummary?.gatewayScore}
        scores={isLoading ? "Loading..." : executiveSummary?.componentScores}
        shortConclusion={
          isLoading
            ? "Loading..."
            : investmentStrategyAndConclusion?.shortConclusion
        }
        isLoading={isLoading}
      />
      <div className="sm:hidden flex flex-col gap-3">
        <p>
          {isLoading
            ? "Loading..."
            : investmentStrategyAndConclusion?.shortConclusion}
        </p>

        <p className="text-xs opacity-50">Component scores: </p>

        <div className="flex flex-col sm:hidden gap-2">
          <ScoreCard
            title="Technical Analysis"
            score={
              isLoading
                ? "0.0"
                : executiveSummary?.gatewayScore?.technicalAnalysis
            }
          />
          <ScoreCard
            title="Fundamental Analysis"
            score={
              isLoading
                ? "0.0"
                : executiveSummary?.gatewayScore?.fundamentalAnalysis
            }
          />
          <ScoreCard
            title="Social Score"
            score={
              isLoading ? "0.0" : executiveSummary?.gatewayScore?.socialScore
            }
          />
        </div>
      </div>
      <div className="flex grow  text-[16px] font-normal leading-[24px]">
        {isLoading
          ? "Loading..."
          : investmentStrategyAndConclusion?.finalConclusion}
      </div>
      <div className="opacity-50 text-xs">
        Disclaimer: This report is for informational purposes only and should
        not be considered financial advice. Cryptocurrency investments are
        highly volatile and risky. Always conduct your own research and consider
        your risk tolerance before making investment decisions.
      </div>
      <Button
        onClick={() => {
          throw new Error("Not implemented");
        }}
        variant="PRIMARY"
        large
      >
        Buy
      </Button>
    </div>
  );
};
